var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3997 4.42095C8.273 4.55351 8.17248 4.71098 8.10389 4.88433C8.0353 5.05768 8 5.2435 8 5.43118C8 5.61885 8.0353 5.80468 8.10389 5.97802C8.17248 6.15137 8.273 6.30884 8.3997 6.4414L13.7028 12.0012L8.3997 17.5611C8.14415 17.829 8.00058 18.1924 8.00058 18.5713C8.00058 18.9502 8.14415 19.3136 8.3997 19.5816C8.65526 19.8495 9.00186 20 9.36327 20C9.72468 20 10.0713 19.8495 10.3268 19.5816L16.6003 13.0043C16.727 12.8717 16.8275 12.7143 16.8961 12.5409C16.9647 12.3676 17 12.1818 17 11.9941C17 11.8064 16.9647 11.6206 16.8961 11.4472C16.8275 11.2739 16.727 11.1164 16.6003 10.9839L10.3268 4.40662C9.80747 3.8621 8.93274 3.8621 8.3997 4.42095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.a1a3d6421d3ca802b2be7c2fa38cf495.svg";
export { ForwardRef as ReactComponent };